/**
 * @file 新闻列表页新闻列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import moment from 'moment';
import {INewsItem} from '../../type';

interface IProps {
    newsList: INewsItem[]
}

const NewsList: React.FC<IProps> = props => {
    const newsList = props.newsList;

    return (
        <div className="paddle-news-list paddle-news-list">
            {newsList.map(theNew => (
                <div
                    key={theNew.id}
                    className="paddle-news-news"
                >
                    {
                        !!theNew.matchImgUrl
                        && <img
                            alt={theNew.title}
                            className="paddle-news-news-img"
                            src={theNew.matchImgUrl}
                        />
                    }

                    <div className="paddle-news-news-info">
                        <a
                            className="paddle-news-news-title"
                            href={theNew.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {theNew.title}
                        </a>
                        <div className="paddle-news-news-desc">{theNew.abs}</div>
                        <div className="paddle-news-news-other">
                            <span className="paddle-news-news-time">
                                发布日期：{moment(theNew.pubTime).format('YYYY-MM-DD')}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NewsList;
